"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function () { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function (obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return { value: void 0, done: !0 }; } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable || "" === iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } throw new TypeError(typeof iterable + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function (skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function () { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function (exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function (type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function (record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function (finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function (tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function (iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var e = require("react"),
  t = require("launchdarkly-js-client-sdk"),
  r = require("lodash.camelcase"),
  n = require("hoist-non-react-statics");
function o(e) {
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (r) {
    if ("default" !== r) {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function () {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var s = o(e);
const a = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0
  },
  i = e.createContext({
    flags: {},
    flagKeyMap: {},
    ldClient: void 0
  }),
  l = i.Provider,
  c = i.Consumer,
  u = e => {
    var t;
    return null != (t = e.context) ? t : e.user;
  },
  p = e => {
    const t = {};
    for (const n in e) 0 !== n.indexOf("$") && (t[r(n)] = e[n]);
    return t;
  },
  f = (e, t) => {
    const r = {};
    for (const n in e) t && void 0 === t[n] || (r[n] = e[n].current);
    return r;
  },
  y = (e, t) => {
    const r = e.allFlags();
    return t ? Object.keys(t).reduce((e, n) => (e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e), {}) : r;
  };
p.camelCaseKeys = p;
var d = Object.defineProperty,
  g = Object.getOwnPropertySymbols,
  b = Object.prototype.hasOwnProperty,
  h = Object.prototype.propertyIsEnumerable,
  O = (e, t, r) => t in e ? d(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  v = (e, t) => {
    for (var r in t || (t = {})) b.call(t, r) && O(e, r, t[r]);
    if (g) for (var r of g(t)) h.call(t, r) && O(e, r, t[r]);
    return e;
  };
const m = {
    wrapperName: "react-client-sdk",
    wrapperVersion: "3.0.8",
    sendEventsOnlyForVariation: !0
  },
  C = function (e) {
    for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      r[_key - 1] = arguments[_key];
    }
    return n = void 0, o = [e, ...r], s = function (e) {
      let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        anonymous: !0,
        kind: "user"
      };
      let n = arguments.length > 2 ? arguments[2] : undefined;
      let o = arguments.length > 3 ? arguments[3] : undefined;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var s;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              s = t.initialize(e, r, v(v({}, m), n));
              return _context.abrupt("return", new Promise(e => {
                function t() {
                  s.off("ready", n), s.off("failed", r);
                }
                function r(r) {
                  t(), e({
                    flags: {},
                    ldClient: s,
                    error: r
                  });
                }
                function n() {
                  t();
                  const r = y(s, o);
                  e({
                    flags: r,
                    ldClient: s
                  });
                }
                s.on("failed", r), s.on("ready", n);
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    }, new Promise((e, t) => {
      var r = e => {
          try {
            i(s.next(e));
          } catch (e) {
            t(e);
          }
        },
        a = e => {
          try {
            i(s.throw(e));
          } catch (e) {
            t(e);
          }
        },
        i = t => t.done ? e(t.value) : Promise.resolve(t.value).then(r, a);
      i((s = s.apply(n, o)).next());
    });
    var n, o, s;
  };
function j(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a;
  let o = arguments.length > 3 ? arguments[3] : undefined;
  const s = function (e, t) {
      if (void 0 === t) return e;
      return Object.keys(t).reduce((t, r) => (P(e, r) && (t[r] = e[r]), t), {});
    }(t, o),
    _n$useCamelCaseFlagKe = n.useCamelCaseFlagKeys,
    i = _n$useCamelCaseFlagKe === void 0 ? !0 : _n$useCamelCaseFlagKe,
    _ref = i ? function (e) {
      const t = {},
        n = {};
      for (const o in e) {
        if (0 === o.indexOf("$")) continue;
        const s = r(o);
        t[s] = e[o], n[s] = o;
      }
      return [t, n];
    }(s) : [s],
    _ref2 = _slicedToArray(_ref, 2),
    l = _ref2[0],
    _ref2$ = _ref2[1],
    c = _ref2$ === void 0 ? {} : _ref2$;
  return {
    flags: n.sendEventsOnFlagRead ? x(e, l, c, i) : l,
    flagKeyMap: c
  };
}
function P(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function x(e, t, r, n) {
  return new Proxy(t, {
    get(t, o, s) {
      const a = Reflect.get(t, o, s),
        i = n && P(r, o) || P(t, o);
      if ("symbol" == typeof o || !i) return a;
      if (void 0 === a) return;
      const l = n ? r[o] : o;
      return e.variation(l, a);
    }
  });
}
var w = Object.defineProperty,
  E = Object.defineProperties,
  F = Object.getOwnPropertyDescriptors,
  D = Object.getOwnPropertySymbols,
  K = Object.prototype.hasOwnProperty,
  S = Object.prototype.propertyIsEnumerable,
  k = (e, t, r) => t in e ? w(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  I = (e, t) => {
    for (var r in t || (t = {})) K.call(t, r) && k(e, r, t[r]);
    if (D) for (var r of D(t)) S.call(t, r) && k(e, r, t[r]);
    return e;
  },
  L = (e, t, r) => (k(e, "symbol" != typeof t ? t + "" : t, r), r),
  M = (e, t, r) => new Promise((n, o) => {
    var s = e => {
        try {
          i(r.next(e));
        } catch (e) {
          o(e);
        }
      },
      a = e => {
        try {
          i(r.throw(e));
        } catch (e) {
          o(e);
        }
      },
      i = e => e.done ? n(e.value) : Promise.resolve(e.value).then(s, a);
    i((r = r.apply(e, t)).next());
  });
class R extends e.Component {
  constructor(e) {
    super(e), L(this, "state"), L(this, "getReactOptions", () => I(I({}, a), this.props.reactOptions)), L(this, "subscribeToChanges", e => {
      const t = this.props.flags;
      e.on("change", r => {
        const n = this.getReactOptions(),
          o = f(r, t),
          s = I(I({}, this.state.unproxiedFlags), o);
        Object.keys(o).length > 0 && this.setState(I({
          unproxiedFlags: s
        }, j(e, s, n, t)));
      });
    }), L(this, "initLDClient", () => M(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props, e, t, r, n, o, s, a, i;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$props = this.props, e = _this$props.clientSideID, t = _this$props.flags, r = _this$props.options;
            _context2.next = 3;
            return this.props.ldClient;
          case 3:
            n = _context2.sent;
            o = this.getReactOptions();
            a = this.state.unproxiedFlags;
            if (!n) {
              _context2.next = 10;
              break;
            }
            a = y(n, t);
            _context2.next = 14;
            break;
          case 10:
            _context2.next = 12;
            return C(e, u(this.props), r, t);
          case 12:
            o = _context2.sent;
            s = o.error, s || (a = o.flags), n = o.ldClient;
          case 14:
            this.setState((i = I({
              unproxiedFlags: a
            }, j(n, a, o, t)), E(i, F({
              ldClient: n,
              error: s
            })))), this.subscribeToChanges(n);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    })));
    const t = e.options;
    if (this.state = {
      flags: {},
      unproxiedFlags: {},
      flagKeyMap: {},
      ldClient: void 0
    }, t) {
      const e = t.bootstrap;
      if (e && "localStorage" !== e) {
        const _this$getReactOptions = this.getReactOptions(),
          t = _this$getReactOptions.useCamelCaseFlagKeys;
        this.state = {
          flags: t ? p(e) : e,
          unproxiedFlags: e,
          flagKeyMap: {},
          ldClient: void 0
        };
      }
    }
  }
  componentDidMount() {
    return M(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var e;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            e = this.props.deferInitialization;
            _context3.t0 = e && !u(this.props);
            if (_context3.t0) {
              _context3.next = 5;
              break;
            }
            _context3.next = 5;
            return this.initLDClient();
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
  }
  componentDidUpdate(e) {
    return M(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var t, r;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            t = this.props.deferInitialization, r = !u(e) && u(this.props);
            _context4.t0 = t && r;
            if (!_context4.t0) {
              _context4.next = 5;
              break;
            }
            _context4.next = 5;
            return this.initLDClient();
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
  }
  render() {
    const _this$state = this.state,
      t = _this$state.flags,
      r = _this$state.flagKeyMap,
      n = _this$state.ldClient,
      o = _this$state.error;
    return e.createElement(l, {
      value: {
        flags: t,
        flagKeyMap: r,
        ldClient: n,
        error: o
      }
    }, this.props.children);
  }
}
var q = Object.defineProperty,
  z = Object.defineProperties,
  T = Object.getOwnPropertyDescriptors,
  V = Object.getOwnPropertySymbols,
  $ = Object.prototype.hasOwnProperty,
  N = Object.prototype.propertyIsEnumerable,
  U = (e, t, r) => t in e ? q(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  W = (e, t) => {
    for (var r in t || (t = {})) $.call(t, r) && U(e, r, t[r]);
    if (V) for (var r of V(t)) N.call(t, r) && U(e, r, t[r]);
    return e;
  };
var A = Object.defineProperty,
  B = Object.getOwnPropertySymbols,
  G = Object.prototype.hasOwnProperty,
  H = Object.prototype.propertyIsEnumerable,
  J = (e, t, r) => t in e ? A(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  Q = (e, t) => {
    for (var r in t || (t = {})) G.call(t, r) && J(e, r, t[r]);
    if (B) for (var r of B(t)) H.call(t, r) && J(e, r, t[r]);
    return e;
  };
var X = Object.defineProperty,
  Y = Object.getOwnPropertySymbols,
  Z = Object.prototype.hasOwnProperty,
  _ = Object.prototype.propertyIsEnumerable,
  ee = (e, t, r) => t in e ? X(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  te = (e, t) => {
    for (var r in t || (t = {})) Z.call(t, r) && ee(e, r, t[r]);
    if (Y) for (var r of Y(t)) _.call(t, r) && ee(e, r, t[r]);
    return e;
  };
exports.LDProvider = R, exports.asyncWithLDProvider = function (t) {
  return r = this, n = null, o = /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var r, n, o, s, i, _yield$C, c, p, y, d;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          r = t.clientSideID;
          n = t.flags;
          o = t.options;
          s = t.reactOptions;
          i = Q(Q({}, a), s);
          _context5.next = 7;
          return C(r, u(t), o, n);
        case 7:
          _yield$C = _context5.sent;
          c = _yield$C.ldClient;
          p = _yield$C.flags;
          y = _yield$C.error;
          d = (null == o ? void 0 : o.bootstrap) && "localStorage" !== o.bootstrap ? o.bootstrap : p;
          return _context5.abrupt("return", _ref3 => {
            let t = _ref3.children;
            const _e$useState = e.useState(() => Q({
                unproxiedFlags: d
              }, j(c, d, i, n))),
              _e$useState2 = _slicedToArray(_e$useState, 2),
              r = _e$useState2[0],
              o = _e$useState2[1];
            e.useEffect(() => {
              function e(e) {
                const t = f(e, n);
                Object.keys(t).length > 0 && o(_ref4 => {
                  let e = _ref4.unproxiedFlags;
                  const r = Q(Q({}, e), t);
                  return Q({
                    unproxiedFlags: r
                  }, j(c, r, i, n));
                });
              }
              return c.on("change", e), function () {
                c.off("change", e);
              };
            }, []);
            const s = r.flags,
              a = r.flagKeyMap;
            return e.createElement(l, {
              value: {
                flags: s,
                flagKeyMap: a,
                ldClient: c,
                error: y
              }
            }, t);
          });
        case 13:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }), new Promise((e, t) => {
    var s = e => {
        try {
          i(o.next(e));
        } catch (e) {
          t(e);
        }
      },
      a = e => {
        try {
          i(o.throw(e));
        } catch (e) {
          t(e);
        }
      },
      i = t => t.done ? e(t.value) : Promise.resolve(t.value).then(s, a);
    i((o = o.apply(r, n)).next());
  });
  var r, n, o;
}, exports.camelCaseKeys = p, exports.defaultReactOptions = a, exports.useFlags = () => {
  const _e$useContext = e.useContext(i),
    t = _e$useContext.flags;
  return t;
}, exports.useLDClient = () => {
  const _e$useContext2 = e.useContext(i),
    t = _e$useContext2.ldClient;
  return t;
}, exports.useLDClientError = function () {
  const _e$useContext3 = e.useContext(i),
    t = _e$useContext3.error;
  return t;
}, exports.withLDConsumer = function () {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clientOnly: !1
  };
  return function (t) {
    return r => s.createElement(c, null, _ref5 => {
      let n = _ref5.flags,
        o = _ref5.ldClient;
      return e.clientOnly ? s.createElement(t, te({
        ldClient: o
      }, r)) : s.createElement(t, te({
        flags: n,
        ldClient: o
      }, r));
    });
  };
}, exports.withLDProvider = function (e) {
  return function (t) {
    const r = e.reactOptions,
      o = W(W({}, a), r),
      i = (l = W({}, e), z(l, T({
        reactOptions: o
      })));
    var l;
    function c(e) {
      return s.createElement(R, W({}, i), s.createElement(t, W({}, e)));
    }
    return n(c, t), c;
  };
};